// extracted by mini-css-extract-plugin
export default {"button":"edit-subscription_button__4dkzJ","title":"edit-subscription_title__v9MsK","caption":"edit-subscription_caption__Dop2m"};